<template>
	<section>
		<div>
			<header-page
				name="web-services"
				:title="$route.meta.title"
			/>
			<div class="px-5">
				<app-table
					class="mt-5 is-not-selectable"
					name="companies"
					:columns="columns"
					:current-page="currentPage"
					:rows="rows"
					:last-page="lastPage"
					@on-page="changePage"
					@on-search-event="onSearch"
				>
					<template slot="rows" slot-scope="props">
						<td
							class="is-not-selectable"
							v-show="showRow(columns, 1)"
						>
							{{ props.row.name }}
						</td>
						<td v-show="showRow(columns, 2)">
							{{ props.row.description }}
						</td>
						<td v-show="showRow(columns, 3)">
							{{ props.row.domain }}
						</td>
						<td v-show="showRow(columns, 4)">
							{{ props.row.method }}
						</td>
						<td v-show="showRow(columns, 5)">
							<v-tooltip 	top>
									<p slot="activator" class="mb-0">{{ props.row.path| limitTo }}</p>
									<span>{{props.row.path}}</span>
							</v-tooltip>
						</td>
						<td v-show="showRow(columns, 6)">
							{{ isPlatform(props.row.platform) }}
						</td>
						<td v-show="showRow(columns, 7)">
							<app-tooltip-button
								color="green"
								icon="edit"
								text="Editar"
								@click-icon="edit(props.row)"
							/>
							<app-tooltip-button
								color="red"
								icon="delete"
								text="Eliminar"
								@click-icon="openModalConfirmation(props.row)"
							/>
						</td>
					</template>
				</app-table>
			</div>
			<quick-actions
				v-if="$route.name === 'page-web-services'"
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
		<router-view></router-view>
	</section>
</template>

<script>
	import quickActions from '@/components/shared/quick-actions';
	import appTooltipButton from '@/components/shared/app-tooltip-button';
	import appConfirmationModal from '@/components/shared/app-confirmation-modal';

	function openModal() {
		this.goTo('page-new-web-services');
	}

	function edit({ id }) {
		this.goTo('page-edit-web-services', { params: { id } });
	}

	async function confirm() {
		try {
			await this.$http.delete(`master-services/${this.modalConfirmation.selectedRow.id}`);
			this.showNotification('El servicio se eliminó correctamente');
			this.cancelModalConfirmation();
			this.loadData();
		} catch (error) {
			this.showError();
		}
	}

	async function loadData() {
		try {
			const response = await this.$http.get('master-services', { params: this.params });
			this.rows = response.data.data;
			this.lastPage = Number(response.headers['x-last-page']);
		} catch (error) {
			this.showError();
		}
	}

	function isPlatform(platform) {
		if (platform === 1) {
			return 'Web';
		} else if (platform === 2) {
			return 'Móvil';
		} else if (platform === 3) {
			return 'Web/Móvil';
		}
		return '-';
	}

	function changePage(page) {
		this.currentPage = page;
		this.params.page = page;
		this.loadData();
	}

	function onSearch(search) {
		this.params.search = search ? search.trim() : null;
		this.loadData();
	}

	function created() {
		this.loadData();
	}

	function data() {
		return {
			actions: [
				{
					id: 1,
					code: 'WS',
					text: 'Agregar Web Services',
					icon: 'cloud_queue',
					active: true,
				},
			],
			columns: [
				{ id: 1, name: 'Nombre', checked: true, visible: true },
				{ id: 2, name: 'Descripción', checked: true, visible: true },
				{ id: 3, name: 'Dominio', checked: true, visible: true },
				{ id: 4, name: 'Método', checked: true, visible: true },
				{ id: 5, name: 'Path', checked: true, visible: true, flagVisible: true },
				{ id: 6, name: 'Plataforma', checked: true, visible: true, flagVisible: true },
				{ id: 7, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			currentPage: 1,
			lastPage: 0,
			rows: [],
			loading: false,
			params: {
				page: 1,
				codeProject: this.codeProject,
			},
		};
	}

	export default {
		name: 'page-web-services',
		data,
		created,
		components: {
			appTooltipButton,
			quickActions,
			appConfirmationModal,
		},
		methods: {
			openModal,
			edit,
			confirm,
			loadData,
			isPlatform,
			changePage,
			onSearch,
		},
		props: {
			codeProject: {
				type: String,
			},
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'page-web-services') {
						this.loadData();
					}
				}
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/web-services/page-web-services.vue